import * as React from 'react';
import * as moment from 'moment';

import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { connect } from 'react-redux';

import ListMonthView from 'list-month.view';
import { ICalendarAppState } from '../../redux-state';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

interface IListMonthExternalProps {
    monthData: IMonth<IEvent>;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type ListMonthProps = IListMonthExternalProps & StateToProps;

export class ListMonthBase extends React.Component<ListMonthProps, any> {
    render() {
        return (
            <ListMonthView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IListMonthExternalProps): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect<StateToProps>(mapStateToProps)(ListMonthBase);